import React from "react";
const ButtonNestingContext = React.createContext(!1);
export { ButtonNestingContext };
//# sourceMappingURL=NestingContext.mjs.map
